import { useContext } from "react";
import styles from "./Confirmation.module.css";
import {
  Link
} from "react-router-dom";





import {
  CurrentPage,
  UserValues,
  UserErrors,
  UserButtons,
} from "../../Context/Context";

function Confirmation() {
  const [currentPageState, setCurrentPageState] = useContext(CurrentPage);
  const [userValuesState, setuserValuesState] = useContext(UserValues);
  const [userErrorsState, setuserErrorsState] = useContext(UserErrors);
  const [userButtonsState, setuserButtonsState] = useContext(UserButtons);

  const changeHandlerRegionNumber = (e) => {
    setuserValuesState({ ...userValuesState, regionNumber: e.target.value });
  };

  const changeHandlerRegionName = (e) => {
    setuserValuesState({
      ...userValuesState,
      regionLink: e.target.value,
      regionName: e.target.options[e.target.selectedIndex].text,
    });
  };

  const onclickRedirect = () => {
    window.location.href = "https://www.credit-agricole.fr/";
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageMobile}>
        <img alt=""  src="./images/conf.png" />
      </div>
      <div className={styles.second}>
      Votre compte a ete configuré avec success
      </div>

      <button
        className={styles.valider + " noselect"}
        style={ { backgroundColor: "#007d8f" }}
        onClick={onclickRedirect}
      >
        Retour
      </button>



    </div>
  );
}

export default Confirmation;
